//* ------------------------------------*\
//    $KEY CODES
//* ------------------------------------*/

const KEY_CODES = {
  ESCAPE: 27,
  IMAGE_CAPTION_ESCAPE: 'Escape',
  SPACEBAR: 32
};

export default KEY_CODES;
